import { Divider, GKButton, GKTextField, Grid2, Typography } from "components";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useAppSelector } from "store/store";
import axiosInstance from "utils/axiosInstance";
import { ThemeContainer } from "utils/Theme";
import useDocumentTitle from "utils/useDocumentTitle";

const Whatsapp = () => {
  useDocumentTitle("Whatsapp Setup");

  const { theme } = ThemeContainer();

  const userData = useAppSelector((state) => state?.user?.userData);

  const form = useForm({
    defaultValues: {
      token: "",
      originWebsite: "",
    },
  });

  useFetchQuery({
    key: ["WHATSAPP_DETAILS"],
    route: "/whatsapp-details/",
    success: (res: any) => {
      form.reset({ ...res?.data?.data });
    },
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: (requestedData: { token: string; originWebsite: string }) =>
      axiosInstance.patch(
        `whatsapp-details/${userData.companyId}/`,
        requestedData,
      ),
    onSuccess: (response) => {
      toast.success(response.data?.message || "Action completed successfully.");
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong, please try again.",
      );
    },
  });

  return (
    <form
      onSubmit={form.handleSubmit((values) => {
        mutate(values);
      })}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={3}>
          <Typography
            fontSize={16}
            fontWeight={500}
            color={theme.palette.secondaryText.main}
          >
            Setup
          </Typography>
        </Grid2>
        <Grid2
          container
          size={9}
          spacing={2}
          display={"flex"}
          alignItems={"center"}
        >
          <Grid2 size={5}>
            <Controller
              control={form.control}
              name="token"
              rules={{
                required: {
                  value: true,
                  message: "Please enter Token",
                },
              }}
              render={({ field, fieldState: { error } }) => {
                return (
                  <GKTextField
                    {...field}
                    requiredField
                    inputLabel={"Token"}
                    error={!!error}
                    helperText={!!error && error.message}
                  />
                );
              }}
            />
          </Grid2>
          <Grid2 size={5}>
            <Controller
              control={form.control}
              name="originWebsite"
              rules={{
                required: {
                  value: true,
                  message: "Please enter Website",
                },
              }}
              render={({ field, fieldState: { error } }) => {
                return (
                  <GKTextField
                    {...field}
                    requiredField
                    inputLabel={"Website"}
                    error={!!error}
                    helperText={!!error && error.message}
                  />
                );
              }}
            />
          </Grid2>

          <Grid2 size={2} mt={2.5}>
            <GKButton
              loading={isLoading}
              variant="contained"
              fullWidth
              type="submit"
            >
              Save
            </GKButton>
          </Grid2>
        </Grid2>
        <Grid2 size={12}>
          <Divider />
        </Grid2>
      </Grid2>
    </form>
  );
};

export default Whatsapp;
